import { __zcFin, __zcIT, __zcITc, __zcMkv } from "__zod-compiler-runtime__";
import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {BrandEnum} from './brand'
import {PersonalisationRuleSchema} from './personalisationRule'

export const OverviewTemplateSettingsSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor('overviewTemplateSettings', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      brand: safeOptional(BrandEnum),
      heroCtaOnePersonalisation: safeOptional(z.array(PersonalisationRuleSchema)),
      heroCtaTwoPersonalisation: safeOptional(z.array(PersonalisationRuleSchema)),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"],__zs._zod.innerType.shape["fields"]._zod.innerType.shape["brand"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["heroCtaOnePersonalisation"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["fields"]._zod.innerType.shape["heroCtaTwoPersonalisation"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __rfp_0=__rf[0].safeParse.bind(__rf[0]);
var __rfn_15=__rf[1];
var __rfn_18=__rf[2];
var __rfn_21=__rf[3];
function safeParse_OverviewTemplateSettingsSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_2=_d["sys"];if(typeof __sv_2!=="object"||__sv_2===null||Array.isArray(__sv_2)){_e.push(__zcIT("object",__sv_2,["sys"]));}else{var __sv_4=__sv_2["id"];if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","id"]));}
var __sv_5=__sv_2["updatedAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","updatedAt"]));}
}
var __sv_6=__sv_2["createdAt"];if(__sv_6!==undefined){if(typeof __sv_6!=="string"){_e.push(__zcIT("string",__sv_6,["sys","createdAt"]));}
}
var __sv_7=__sv_2["contentType"];var __op_9="contentType" in __sv_2;var __ob_8=_e.length;var __rf_r0=__rfp_0(__sv_7);if(!__rf_r0.success){var __rf_i0=__rf_r0.error.issues;for(var __rf_j0=0;__rf_j0<__rf_i0.length;__rf_j0++){_e.push({...__rf_i0[__rf_j0],path:["sys","contentType"].concat(__rf_i0[__rf_j0].path)});}}else{__sv_7=__rf_r0.data;}
if(!__op_9){__sv_7=undefined;if(_e.length===__ob_8){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_3={"id":__sv_4};if(__sv_5!==undefined||("updatedAt" in __sv_2)){__o_3["updatedAt"]=__sv_5;}if(__sv_6!==undefined||("createdAt" in __sv_2)){__o_3["createdAt"]=__sv_6;}if(__sv_7!==undefined||("contentType" in __sv_2)){__o_3["contentType"]=__sv_7;}__sv_2=__o_3;}
var __sv_10=_d["fields"];if(typeof __sv_10!=="object"||__sv_10===null||Array.isArray(__sv_10)){_e.push(__zcIT("object",__sv_10,["fields"]));}else{var __sv_12=__sv_10["title"];if(typeof __sv_12!=="string"){_e.push(__zcIT("string",__sv_12,["fields","title"]));}
var __sv_13=__sv_10["brand"];if(__sv_13!==undefined){var __ib_14=_e.length;if(_e.length===__ib_14){__sv_13=__rfn_15(__sv_13);}
}
var __sv_16=__sv_10["heroCtaOnePersonalisation"];if(__sv_16!==undefined){var __ib_17=_e.length;if(_e.length===__ib_17){__sv_16=__rfn_18(__sv_16);}
}
var __sv_19=__sv_10["heroCtaTwoPersonalisation"];if(__sv_19!==undefined){var __ib_20=_e.length;if(_e.length===__ib_20){__sv_19=__rfn_21(__sv_19);}
}
var __o_11={"title":__sv_12};if(__sv_13!==undefined||("brand" in __sv_10)){__o_11["brand"]=__sv_13;}if(__sv_16!==undefined||("heroCtaOnePersonalisation" in __sv_10)){__o_11["heroCtaOnePersonalisation"]=__sv_16;}if(__sv_19!==undefined||("heroCtaTwoPersonalisation" in __sv_10)){__o_11["heroCtaTwoPersonalisation"]=__sv_19;}__sv_10=__o_11;}
var __o_1={"sys":__sv_2,"fields":__sv_10};_d=__o_1;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_OverviewTemplateSettingsSchema,__zs,null,null);
})()
export type OverviewTemplateSettings = z.infer<typeof OverviewTemplateSettingsSchema>
